import { updatesData } from '@/mocks/home';

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
              最新动态
            </h2>
            <p className="mt-3 text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
              平台更新、新剧上线、运营活动一手掌握
            </p>
          </div>

          <div className="relative">
            <div className="absolute left-4 md:left-5 top-0 bottom-0 w-px bg-secondary-300" />

            <div className="flex flex-col gap-6">
              {updatesData.map((item) => (
                <div key={item.id} className="relative pl-10 md:pl-12 group cursor-pointer">
                  <div className="absolute left-2 md:left-3 top-1.5 w-5 h-5 rounded-full border-2 border-primary-500 bg-background-50 group-hover:bg-primary-500 transition-colors" />

                  <div className="flex items-baseline gap-2 mb-1">
                    <span className="text-xs font-medium text-primary-500 bg-primary-50 px-2 py-0.5 rounded whitespace-nowrap">
                      {item.tag}
                    </span>
                    <span className="text-xs text-foreground-400 whitespace-nowrap">{item.time}</span>
                  </div>
                  <h3 className="text-sm md:text-base font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors">
                    {item.title}
                  </h3>
                  <p className="mt-1 text-xs md:text-sm text-foreground-600 leading-relaxed">
                    {item.description}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}